const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

const benefits = [
  {
    icon: 'ri-award-line',
    title: 'Certifications Reconnues',
    description: 'Obtenez des diplômes et certificats professionnels reconnus par les entreprises de Kinshasa et de la RDC.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Formation 100% Pratique',
    description: 'Apprenez sur du matériel réel. Nos ateliers sont équipés des dernières technologies pour une expérience concrète.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Formateurs Experts',
    description: 'Nos instructeurs sont des professionnels actifs avec plus de 10 ans d\'expérience terrain dans leurs domaines.',
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'Insertion Professionnelle',
    description: 'Réseau de partenaires employeurs. 95% de nos diplômés trouvent un emploi ou lancent leur activité dans les 3 mois.',
  },
  {
    icon: 'ri-time-line',
    title: 'Horaires Flexibles',
    description: 'Cours du matin, du soir et le week-end. Formez-vous sans sacrifier votre emploi ou vos activités actuelles.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Tarifs Accessibles',
    description: 'Des formations de qualité à des prix adaptés au contexte congolais. Paiement en plusieurs tranches possible.',
  },
];

export default function BenefitsSection() {
  return (
    <section id="avantages" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left Image */}
          <div className="w-full lg:w-[420px] flex-shrink-0 relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/8aeff747648752361f097bb3a9e35bf9.jpg"
                alt="Campus Négus Tech - Centre de formation"
                className="w-full h-[520px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/30 to-transparent"></div>
            </div>
            {/* Certified badge */}
            <div className="absolute top-6 -right-4 bg-[#f5c518] rounded-xl px-5 py-3 shadow-lg">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-medal-line text-[#0a1628] text-xl"></i>
                </div>
                <div>
                  <div className="text-[#0a1628] font-black text-sm">Certifié</div>
                  <div className="text-[#0a1628]/70 text-xs">Professionnel</div>
                </div>
              </div>
            </div>
            {/* Students count badge */}
            <div className="absolute -bottom-4 -left-4 bg-[#0a1628] rounded-xl px-5 py-4 shadow-lg">
              <div className="text-[#f5c518] font-black text-2xl">500+</div>
              <div className="text-white/70 text-xs">Étudiants formés</div>
            </div>
          </div>

          {/* Right Content */}
          <div className="flex-1">
            <span className="inline-block bg-[#f5c518]/20 text-[#0a1628] text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
              Un centre de formation dernière génération&nbsp;
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-[#0a1628] mb-4 leading-tight">
              La formation qui&nbsp;<span className="text-[#f5c518]">donne du travail</span>&nbsp;
            </h2>
            <p className="text-gray-500 text-lg mb-10 leading-relaxed">
              Notre centre de formation technique professionnelle européenne basé à Kinshasa offre une expérience 100% pratique, orienté employabilité. Pas de théorie inutile -que du pratique
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {benefits.map((benefit) => (
                <div
                  key={benefit.title}
                  className="flex gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors duration-200 group"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-[#f5c518]/15 rounded-xl flex-shrink-0 group-hover:bg-[#f5c518]/30 transition-colors duration-200">
                    <i className={`${benefit.icon} text-[#0a1628] text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-[#0a1628] font-bold text-base mb-1">{benefit.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-10">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#0a1628] text-white font-bold text-base px-8 py-4 rounded-full hover:bg-[#0d1f3c] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-[#f5c518] text-lg"></i>
                </div>
                Rejoindre Campus Négus Tech
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
